import {Button} from '@gongxigames/framework/core';
import {Container, Graphics, InteractionEvent, Sprite} from 'pixi.js';

export class SoundSlider {
    private _thumb: Button;
    private _fullSlider: Sprite;
    private _bg: Sprite;
    private _drugging = false;
    private _currentValue = 0;

    private _changedCallback?: Function;
    private startThumbPosition: number;
    private endThumbPosition: number;

    constructor(sprite: Sprite) {
        this._thumb = (sprite.getChildByName<Sprite>('thumbButtonContainer')).getChildByName<Button>('thumbButton');
        this._fullSlider = sprite.getChildByName<Sprite>('fullSlider');
        this._bg = sprite.getChildByName<Sprite>('bg');

        this.startThumbPosition = this._fullSlider.y;
        this.endThumbPosition = this._fullSlider.y + this._fullSlider.getLocalBounds().height;

        const mask = new Graphics();

        mask.beginFill(0xFFFFFF);
        mask.drawRect(0, 0, 1, 1);
        mask.endFill();
        mask.width = this._fullSlider.getLocalBounds().width;
        mask.height = this._fullSlider.getLocalBounds().height;

        this._fullSlider.mask = mask;
        this._fullSlider.addChild(mask);

        this._thumb.anchor.y = 0.5;
        this._bg.buttonMode = true;
        this._bg.interactive = true;
        this._bg
            .on('mousedown', this.onMouseDown.bind(this))
            .on('mousemove', this.onMouseMove.bind(this))
            .on('mouseup', this.onMouseUp.bind(this))
            .on('mouseupoutside', this.onMouseUp.bind(this));

        this._bg
            .on('touchstart', this.onMouseDown.bind(this))
            .on('touchmove', this.onMouseMove.bind(this))
            .on('touchend', this.onMouseUp.bind(this))
            .on('touchendoutside', this.onMouseUp.bind(this));

        this._thumb
            .on('mousedown', this.onMouseDown.bind(this))
            .on('mousemove', this.onMouseMove.bind(this))
            .on('mouseup', this.onMouseUp.bind(this))
            .on('mouseupoutside', this.onMouseUp.bind(this));

        this._thumb
            .on('touchstart', this.onMouseDown.bind(this))
            .on('touchmove', this.onMouseMove.bind(this))
            .on('touchend', this.onMouseUp.bind(this))
            .on('touchendoutside', this.onMouseUp.bind(this));

        this.slideTo(0);
    }

    public setValue(value: number, callCallback = false): void {
        this._currentValue = value;
        this.updateThumbPosition((1 - value) * this._fullSlider.getLocalBounds().height);
        callCallback && this._changedCallback && this._changedCallback(this._currentValue);
    }

    public reset(): void {
        this.slideTo(0);
        this._changedCallback && this._changedCallback(this._currentValue);
    }

    protected onMouseDown(e: InteractionEvent): void {
        this._drugging = true;
        this.update(e);
    }

    protected onMouseMove(e: InteractionEvent): void {
        this.update(e);
    }

    protected onMouseUp(): void {
        this._drugging = false;

        this.slideTo(this._thumb.position.y);
    }

    protected update(e: InteractionEvent): void {
        if (!this._drugging) {
            return;
        }

        let targetY = e.data.getLocalPosition(this._fullSlider).y;

        if (targetY < 0) {
            targetY = 0;
        } else if (targetY > this._fullSlider.getLocalBounds().height) {
            targetY = this._fullSlider.getLocalBounds().height;
        }

        this.slideTo(targetY);
    }

    protected slideTo(y: number): void {
        this._currentValue = 1 - y / this._fullSlider.getLocalBounds().height;

        this.updateThumbPosition(y);
        this._changedCallback && this._changedCallback(this._currentValue);
    }

    protected updateThumbPosition(y: number): void {
        this._thumb.y = y;
        (this._fullSlider.mask as Container).position.y = y;
    }

    public set changedCallback(value: Function) {
        this._changedCallback = value;
    }

    public get value(): number {
        return this._currentValue;
    }

    public get drugging(): boolean {
        return this._drugging;
    }
}
